// import React from 'react';
// import styles from './Globe.module.css';

// const Globe = () => (
//   <div className={styles.container}>
//     <div className={styles.earth}>
//       <div className={styles.map}></div>
//       <div className={styles.shadowOverlay}></div>
//     </div>
//     <h1 style={{fontSize: '2rem', letterSpacing: '2px'}}>ACCEL<span style={{color: 'var(--primary)'}}>1</span></h1>
//   </div>
// );
// export default Globe;

import React from 'react';
import styles from './Globe.module.css';
import Logo from '../../../assets/accel-logo.png';


const Globe = () => (
  <div className={styles.container}>
    {/* <div className={styles.earth}>
      <div className={styles.map}></div>
    </div> */}
    {/* <h1 style={{fontSize: '2rem', letterSpacing: '2px', marginTop: '20px'}}>
      ACCEL<span style={{color: 'var(--primary)'}}>1</span>
    </h1> */}
    {/* <div className='height-330'></div>   */}
    
  <div className={styles.logoWidth}>  <img src={Logo} alt="Logo" /></div>
  </div>
);
export default Globe;